import React, { useEffect, useRef, useState } from "react";
import { Galleria } from "primereact/galleria";

export default function TestimoniosGallery({
  videos = [],
  height = 520,
  maxWidth = 520,
}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [playingIndex, setPlayingIndex] = useState(null);
  const videoRefs = useRef({});

  useEffect(() => {
    Object.keys(videoRefs.current).forEach((key) => {
      const index = Number(key);
      const video = videoRefs.current[index];

      if (!video) return;

      if (index !== activeIndex) {
        video.pause();
        video.currentTime = 0;
      }
    });

    if (playingIndex !== activeIndex) {
      setPlayingIndex(null);
    }
  }, [activeIndex, playingIndex]);

  const handleTogglePlay = (index) => {
    const video = videoRefs.current[index];
    if (!video) return;

    if (playingIndex === index && !video.paused) {
      video.pause();
      setPlayingIndex(null);
      return;
    }

    Object.keys(videoRefs.current).forEach((key) => {
      const otherIndex = Number(key);
      const otherVideo = videoRefs.current[otherIndex];

      if (!otherVideo) return;

      if (otherIndex !== index) {
        otherVideo.pause();
        otherVideo.currentTime = 0;
      }
    });

    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          setPlayingIndex(index);
        })
        .catch(() => {});
    } else {
      setPlayingIndex(index);
    }
  };

  const handleVideoEnd = (index) => {
    const video = videoRefs.current[index];

    if (video) {
      video.pause();
      video.currentTime = 0;
    }

    setPlayingIndex(null);

    if (videos.length > 0) {
      setActiveIndex((prev) => (prev + 1) % videos.length);
    }
  };

  const itemTemplate = (item) => {
    const index = videos.findIndex((video) => video.src === item.src);
    const isPlaying = playingIndex === index;

    return (
      <div
        className="flex justify-content-center align-items-center"
        style={{
          width: "100%",
          height,
          borderRadius: 20,
          overflow: "hidden",
          position: "relative",
          background:
            "radial-gradient(1200px 1200px at 85% 20%, rgba(15,59,99,0.05), transparent 60%)",
          cursor: "pointer",
        }}
        onClick={() => handleTogglePlay(index)}
      >
        <video
          ref={(el) => {
            if (el) {
              videoRefs.current[index] = el;
            }
          }}
          src={item.src}
          poster={item.poster}
          preload="metadata"
          playsInline
          controls={false}
          onEnded={() => handleVideoEnd(index)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            display: "block",
            backgroundColor: "#000",
          }}
        />

        {!isPlaying && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(0,0,0,0.18)",
              pointerEvents: "none",
            }}
          >
            <div
              style={{
                width: 74,
                height: 74,
                borderRadius: "50%",
                background: "rgba(0,0,0,0.65)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
              }}
            >
              <span
                className="pi pi-play"
                style={{
                  color: "#fff",
                  fontSize: "1.5rem",
                  marginLeft: "4px",
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      style={{
        borderRadius: 24,
        border: "1px solid rgba(15,59,99,0.08)",
        boxShadow: "0 8px 24px rgba(15,59,99,0.08)",
        padding: "0.5rem",
      }}
    >
      <Galleria
        value={videos}
        activeIndex={activeIndex}
        onItemChange={(e) => setActiveIndex(e.index)}
        circular
        showThumbnails={false}
        showIndicators={false}
        showIndicatorsOnItem={false}
        showItemNavigators
        item={itemTemplate}
        pt={{
          root: { style: { borderRadius: 20 } },
          itemWrapper: { style: { borderRadius: 20 } },
          previousItemButton: {
            style: {
              background: "rgba(0,0,0,0.06)",
              borderRadius: 999,
              width: 44,
              height: 44,
              border: "none",
            },
          },
          nextItemButton: {
            style: {
              background: "rgba(0,0,0,0.06)",
              borderRadius: 999,
              width: 44,
              height: 44,
              border: "none",
            },
          },
        }}
        style={{ width: "100%", maxWidth, margin: "0 auto" }}
      />
    </div>
  );
}
